import axios from 'axios';

import {
  RAYCHAT_AFFILIATE_API_URL,
  RAYCHAT_AFFILIATE_PUT_API_URL,
} from 'utils/constants';

export const handleFetchAffiliateData = async () => {
  const response = await axios.get(RAYCHAT_AFFILIATE_API_URL, {
    withCredentials: true,
  });
  return response.data;
};

export const handleSaveAffiliateData = async (data) => {
  const response = await axios.put(RAYCHAT_AFFILIATE_PUT_API_URL, data, {
    withCredentials: true,
  });

  return response.data;
};
